<!-- Header -->
<app-details-page-header
  [title]="title()"
  [id]="projectId() || ''"
  (back)="goBack()"
>
  <app-schedule-meeting
    [projectId]="projectId()"
    [meeting]="currentMeeting()"
    [btnDisabled]="loadingMeetings()"
    [hasContact]="project()?.contactUserId != null"
    [loadingMeetings]="loadingMeetings()"
    (created)="reloadAll()"
  />
  <app-button
    [loading]="isEditing()"
    [disabled]="isEditing()"
    [iconClass]="'fas fa-edit'"
    [label]="'admin.projectIdeas.actions.edit' | translate"
    btnClass="btn btn-falcon-default btn-sm d-flex align-items-center gap-2"
    (clicked)="onEdit()"
  />
  <app-button
    [iconClass]="'fas fa-eye'"
    [label]="'admin.allProjects.actions.view' | translate"
    btnClass="btn btn-primary  btn-sm d-flex align-items-center gap-2"
    (clicked)="onViewProject()"
  />
</app-details-page-header>

<!-- Other content -->
<app-sales-contact-card
  [visible]="showSalesContact()"
  [projectId]="projectId()"
  [project]="project()!"
  (updated)="reloadAll()"
/>

<app-meeting-alert
  [meeting]="currentMeeting()"
  [loading]="loadingMeetings() || isLoading()"
  (cancel)="onCancelMeeting($event)"
  (done)="onMeetingDone($event)"
></app-meeting-alert>

<!-- Main content -->
<div class="card card-details shadow-sm border-0 py-2 mt-3">
  <ul class="nav nav-tabs mb-2" role="tablist">
    <li class="nav-item" role="presentation" *ngFor="let tab of tabs">
      <a
        class="nav-link"
        [class.active]="activeTab() === tab.key"
        role="tab"
        [attr.aria-controls]="tab.key"
        [attr.aria-selected]="activeTab() === tab.key"
        (click)="setTab(tab.key)"
      >
        {{ tab.label | translate }}
      </a>
    </li>
  </ul>

  <div class="tab-content">
    <div
      class="tab-pane fade m-3"
      [class.show]="activeTab() === 'general'"
      [class.active]="activeTab() === 'general'"
      id="general"
      role="tabpanel"
    >
      <app-general-tab
        [project]="project()"
        [files]="files()"
        [contactUserId]="project()?.contactUserId ?? null"
      ></app-general-tab>
    </div>

    <div
      class="tab-pane fade m-3"
      [class.show]="activeTab() === 'incomingOffers'"
      [class.active]="activeTab() === 'incomingOffers'"
      id="incomingOffers"
      role="tabpanel"
    >
      <app-incoming-tab [projectId]="projectId()" />
    </div>

    <!-- TODO: obligations -->
  </div>
</div>
